import Vue from 'vue'
import Router from 'vue-router'
import Main from "../src/Main.vue";
import Unsubscribe from "@/views/Unsubscribe";
import FormTest from "@/views/FormTest";
import Landing from "@/views/Landing";
import Results from "@/views/Results";



Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Landing
    },
    {
      path: '/results*',
      name: 'results',
      component: Results
    },
    {
      path: '/formtest',
      name: 'formtest',
      component: FormTest
    },
    {
      path: '/form*',
      name: 'form',
      component: Main
    },
    {
      path: '/unsubscribe',
      name: 'unsubscribe',
      component: Unsubscribe
    },
  ]
})
